export default __webpack_public_path__ + "static/media/visa.7652dd14.svg";